import SeoArticleLayout from '@/components/feature/SeoArticleLayout';
import { seoArticles } from '@/mocks/seo-articles';

export default function BeginnerTipsPage() {
  return <SeoArticleLayout article={seoArticles[8]} />;
}